export default __webpack_public_path__ + "static/media/Home-foto-header-partners-Tower-viajes-desk.81f7b8e8.jpg";